<script lang="ts" module>
  import { X } from 'phosphor-svelte';

  export interface MiniCartProps {
    /** On close event handler. */
    onclose?: () => void;
    /** A Svelte snippet containing the checklist items. */
    children?: Snippet;
    /** Custom CSS styles for the component. */
    css?: SystemStyleObject;
  }
</script>

<script lang="ts">
  import type { Snippet } from "svelte";
  import type { SystemStyleObject } from "@agapi/ui/panda/types";
  import { css } from "@agapi/ui/panda/css";
  import { hstack, icon } from "@agapi/ui/panda/patterns";
  import { miniCartStyles } from './minicart.styles';

  const { children, onclose, css: cssProp}: MiniCartProps = $props();

  const classes = miniCartStyles.raw();
</script>

<div class={css(classes.header, cssProp)}>
  <div class={hstack({ gap: "tight" })}>
    {@render children?.()}
  </div>
  <X class={icon({ color: 'surface.primary.subdued.foreground', size: 'md', cursor: 'pointer' })} onclick={onclose} />
</div>
